document.addEventListener("DOMContentLoaded", function() {
  $('.recipe-explore-more-slider').slick({
    dots: true,
    appendDots: $('.recipe-explore-more-dots'),
    arrows: true,
    prevArrow: $('.recipe-explore-more-prev'),
    nextArrow: $('.recipe-explore-more-next'),
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 1 }
      }
    ]
  });
});
